import { MedSolTheme, MedSolInputStatus } from '@ms/medsol-components';

export const generateMedSolStatusTextColor = (status: MedSolInputStatus = 'default') =>
    ({
        default: MedSolTheme.colors.SincereSlate,
        success: MedSolTheme.colors.Success,
        warning: MedSolTheme.colors.Concrete,
        error: MedSolTheme.colors.Error,
    }[status]);
